/*
 * Copyright (C) 2025 JPMorgan Chase & Company
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, is not permitted.
 */

import React, {useState, useEffect, useCallback} from 'react';
import './IntroScreen.scss';
import { ExdsGrid, ExdsLayout, ExdsText } from '@exds/core';
import {useNavigate} from 'react-router-dom';

export default function IntroScreen() {
  const navigate = useNavigate();
  const [showFirstText, setShowFirstText] = useState(false);
  const [showSecondText, setShowSecondText] = useState(false);
  const [fadeOut, setFadeOut] = useState(false);

  const onComplete = useCallback(() => {
    navigate("/validateIdentity");
  }, [navigate]);

  useEffect(() => {
    const firstTextTimeout = setTimeout(() => {
      setShowFirstText(true);
    }, 500);

    const secondTextTimeout = setTimeout(() => {
      setShowSecondText(true);
    }, 2000);

    const transitionTimeout = setTimeout(() => {
      setFadeOut(true);
      setTimeout(onComplete, 1000);
    }, 4000);

    return () => {
      clearTimeout(firstTextTimeout);
      clearTimeout(secondTextTimeout);
      clearTimeout(transitionTimeout);
    };
  }, [onComplete]);

  return(
    <>
      <div className={`intro-screen ${fadeOut ? 'fade-out' : ''}`}>
        <ExdsGrid
        columnSpan={12}
        container
        flexDirection="row"
        justifyContent="center"
        alignItems="center"
      >
        <ExdsLayout
          display="flex"
          flexDirection="row"
          justifyContent="center"
          flexWrap="nowrap"
          gap="16px"
        >
          <div className="intro-content">
            <div className={`intro-text ${showFirstText ? 'fade-in' : ''}`}>
              <ExdsText className="intro-text-message" textStyle="headlineSmall" primitive="h1">We're glad you’re here! </ExdsText>
            </div>
            <div className={`intro-text ${showSecondText ? 'fade-in' : ''}`}>
              <ExdsText className="intro-text-message" textStyle="headlineSmall" primitive="h1">Let’s set up your access.</ExdsText>
            </div>
          </div>
            <img className="jpmc-logo" src="../../assets/images/JPMC_Logo.svg" alt="JPMC Logo" />
        </ExdsLayout>
      </ExdsGrid>
      </div>
    </>
  );
}


